import React from 'react'
import PropTypes from 'prop-types'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { normalizeAvatarSrc } from '../Utils/avatarSrc'

const avatarSizes = {
  tinyAvatar: 32,
  smallAvatar: 40,
  mediumAvatar: 60,
  bigAvatar: 80,
  hugeAvatar: 128
}

const getNameSize = (size) => {
  switch (size) {
    case 'tinyAvatar':
    case 'smallAvatar':
    case 'mediumAvatar':
      return 'subtitle2'
    default:
      return 'h6'
  }
}

const UserAvatar = ({ anearUser, size = 'smallAvatar', withName = false, imgProps = {} }) => {
  const avatarSize = avatarSizes[size] || avatarSizes.smallAvatar
  const withNameSize = withName ? getNameSize(size) : null
  const avatarSx = {
    bgcolor: 'primary.main',
    color: '#fff',
    height: avatarSize,
    width: avatarSize
  }
  const avatarSrc = normalizeAvatarSrc(anearUser.avatarUrl())

  return (
    <Box>
      <Avatar sx={avatarSx} imgProps={imgProps} alt={anearUser.name()} src={avatarSrc || undefined}>
        {anearUser.initial()}
      </Avatar>
      {withName && (
        <Typography sx={{ display: 'inline-block', mt: 1 }} color="secondary" variant={withNameSize} align="center">
          {anearUser.name()}
        </Typography>
      )}
    </Box>
  )
}

UserAvatar.propTypes = {
  anearUser: PropTypes.object.isRequired,
  imgProps: PropTypes.object,
  size: PropTypes.string,
  withName: PropTypes.bool
}

export default UserAvatar
